import React from "react";
import { MutedMicrophoneIcon } from "../../SvgIcons/MutedMicrophoneIcon";
import { MicrophoneIcon } from "../../SvgIcons/MicroPhoneIcon";

interface MuteButtonProps {
  muted: boolean;
  onToggle: () => void;
  color?: string;
  backgroundColor?: string;
  mutedColor?: string;
  mutedBGColor?: string;
  hoverBGColor?: string;
  mutedHoverBGColor?: string;
}

const MuteButton: React.FC<MuteButtonProps> = ({
  muted,
  onToggle,
  backgroundColor = "#7E57C2",
  hoverBGColor = "#6846a1",
  mutedBGColor = "#555",
  mutedHoverBGColor = "#666",
}) => {
  const bgColor = muted ? backgroundColor : mutedBGColor;
  const hoverColor = muted ? hoverBGColor : mutedHoverBGColor;

  return (
    <button
      onClick={onToggle}
      style={{
        backgroundColor: bgColor,
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.backgroundColor = hoverColor)
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor = bgColor)
      }
      className={`w-14 h-14 text-white text-xl rounded-2xl flex justify-center align-middle items-center transition`}
    >
      {muted ? <MutedMicrophoneIcon size={20} /> : <MicrophoneIcon size={20} />}
    </button>
  );
};

export default MuteButton;
